import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import PortfolioPositionLayer from "../../components/Trading/PortfolioPositionLayer";

const PortfolioPositionPage = () => {
  return (
    <MasterLayout>
      <PortfolioPositionLayer />
    </MasterLayout>
  );
};

export default PortfolioPositionPage;
